import { MessageCircle, CalendarDays } from "lucide-react";
import { track } from "@/lib/analytics";

export default function FloatingActions({ onBook }) {
  const phone = "918017999746";
  const waMessage = encodeURIComponent(
    "Hi BLEZZINGS, I'd like to explore how you can help my business grow."
  );

  return (
    <>
      <div
        data-testid="floating-actions"
        className="fixed bottom-24 sm:bottom-6 right-6 z-30 flex flex-col items-end gap-3"
      >
        <a
          data-testid="whatsapp-chat-btn"
          href={`https://wa.me/${phone}?text=${waMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
          onClick={() => track("whatsapp_click", { source: "floating" })}
          className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-black text-white shadow-lg ring-1 ring-white/25 hover:bg-[#25D366] transition-colors duration-300"
        >
          <MessageCircle className="h-5 w-5" />
        </a>

        <button
          data-testid="floating-book-btn"
          onClick={onBook}
          aria-label="Book a consultation"
          className="group hidden sm:inline-flex items-center justify-center gap-2 h-12 min-w-[48px] px-3.5 sm:pl-4 sm:pr-5 bg-black text-white text-sm font-medium shadow-lg ring-1 ring-white/25 hover:bg-white hover:text-black hover:ring-black transition-colors duration-300"
        >
          <CalendarDays className="h-4 w-4 shrink-0" />
          <span>Book a Call</span>
        </button>
      </div>

      {/* Mobile sticky CTA bar — replaces the icon button on small screens */}
      <div
        data-testid="mobile-sticky-book-bar"
        className="fixed bottom-0 inset-x-0 z-30 sm:hidden bg-white/95 backdrop-blur border-t border-black/10 p-3"
      >
        <button
          data-testid="mobile-sticky-book-btn"
          onClick={onBook}
          className="w-full h-12 bg-black text-white text-[15px] font-medium inline-flex items-center justify-center gap-2 hover:bg-zinc-800 transition-colors duration-300"
        >
          <CalendarDays className="h-4 w-4" />
          Book a Consultation
        </button>
      </div>
      <div aria-hidden className="h-[76px] sm:hidden" />
    </>
  );
}
